import React, { useState, useEffect } from "react"
import { fetchAirports } from "../../../lib/queries"
import AdminTable from '../../../components/AdminTable'
import AirportModal from './AirportModal'
import ConfirmationModal from "../../../components/ConfirmationModal"
import { addAirport, updateAirport, deleteAirport } from "../../../lib/actions"

const CREATE_ACTION = "create"
const UPDATE_ACTION = "update"
const DELETE_ACTION = "delete"

function AirportsTable() {
    const [airports, setAirports] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        loadAirports()
    }, [])

    const loadAirports = async () => {
        try {
            const data = await fetchAirports()
            setAirports(data)
        } catch (error) {
            console.error("Error loading airports:", error)
        } finally {
            setLoading(false)
        }
    }

    const toggleModal = (modalName) => {
        if (modalName === showModal) {
            setShowModal(false)
        } else {
            setShowModal(modalName)
        }
    }

    const handleSubmit = async (data, action) => {
        try {
            if (action === UPDATE_ACTION) {
                await updateAirport(data.id, data)
            } else if (action === CREATE_ACTION) {
                await addAirport(data)
            } else if (action === DELETE_ACTION) {
                await deleteAirport(data.id)
            }
            await loadAirports()
            setShowModal(false)
        } catch (error) {
            console.error("Error saving airport:", error)
        }
    }
    const filteredAirports = airports.filter((airport) =>
        !searchTerm || (airport.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
            airport.label.toLowerCase().includes(searchTerm.toLowerCase()))
    )

    if (loading) {
        return <div>Loading...</div>
    }

    return (
        <section>
            <div className="row mb-3">
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search airports..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                {showModal === "createAirport" && <AirportModal
                    isOpen={showModal === "createAirport"}
                    onClose={() => toggleModal("createAirport")}
                    mode={CREATE_ACTION}
                    onSubmit={(data) => handleSubmit(data, CREATE_ACTION)}
                />}
                <div className="col-md-4 ms-auto text-end">
                    <button
                        className="btn btn-primary"
                        onClick={() => toggleModal("createAirport")}
                    >
                        Add New Airport
                    </button>
                </div>
            </div>

            <AdminTable>
                <thead className="thead-light">
                    <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Label</th>
                        <th>Name</th>
                        <th>Address</th>
                        <th>Country</th>
                        <th>Timezone</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredAirports.map((airport, index) => (
                        <tr key={airport.id}>
                            <td>{index + 1}</td>
                            <td>{airport.code}</td>
                            <td>{airport.label}</td>
                            <td>{airport.name}</td>
                            <td>{airport.address}</td>
                            <td>{airport.country}</td>
                            <td>{airport.timezone}</td>
                            <td>
                                {showModal === "editAirport" + index && <AirportModal
                                    isOpen={showModal === "editAirport" + index}
                                    onClose={() => toggleModal("editAirport" + index)}
                                    mode={UPDATE_ACTION}
                                    airportData={airport}
                                    onSubmit={(data) => handleSubmit(data, UPDATE_ACTION)}
                                />}
                                {showModal === "deleteAirport" + index && <ConfirmationModal
                                    isOpen={showModal === "deleteAirport" + index}
                                    onClose={() => toggleModal("deleteAirport" + index)}
                                    actionBtnText="Delete"
                                    onAction={() => handleSubmit(airport, DELETE_ACTION)}
                                    title="Delete Airport"
                                    body="Are you sure you want to delete this airport?"
                                />}
                                <span className="material-symbols-outlined text-primary-color" onClick={() => toggleModal("editAirport" + index)} style={{ cursor: "pointer" }}>
                                    edit
                                </span>
                                <span className="material-symbols-outlined text-red-color ms-2" onClick={() => toggleModal("deleteAirport" + index)} style={{ cursor: "pointer" }}>
                                    delete
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </AdminTable>
        </section>
    )
}

export default AirportsTable 